module.exports = __webpack_public_path__ + "img/index_bg.83fa95fb.png";